import {
  LayoutDashboard,
  ClipboardList,
  Users,
  BarChart3,
  LogOut,
  User
} from "lucide-react";

import { useNavigate, useLocation } from "react-router-dom";
import { useState, useEffect } from "react";

function Sidebar({ show, closeSidebar }) {
  const navigate = useNavigate();
  const location = useLocation();

  // ✅ reactive user
  const [user, setUser] = useState(JSON.parse(localStorage.getItem("user")));

  useEffect(() => {
    const updateUser = () => {
      setUser(JSON.parse(localStorage.getItem("user")));
    };

    window.addEventListener("storageUpdate", updateUser);
    return () => window.removeEventListener("storageUpdate", updateUser);
  }, []);

  const handleLogout = () => {
    localStorage.clear();
    navigate("/");
  };

  const isActive = (path) => location.pathname.startsWith(path);
  const role = user?.role?.toLowerCase();

  return (
    <aside className={`sidebar ${show ? "open" : ""}`}>
      <div className="sb-inner">

        <div className="sb-logo">
          <div className="li">Hulm</div>
          <div>
            <div className="ln">Hulm IT Solution</div>
            <div className="ls">Job Tracking</div>
          </div>
        </div>

        <div className="divider"></div>

        <div className="sb-section">MAIN</div>

        <button
          className={`sb-btn ${isActive("/dashboard") ? "act" : ""}`}
          onClick={() => {
            navigate("/dashboard");
            closeSidebar();
          }}
        >
          <LayoutDashboard size={18} />
          Dashboard
        </button>

        {role !== "staff" && (
          <button
            className={`sb-btn ${isActive("/create-job") ? "act" : ""}`}
            onClick={() => {
              navigate("/create-job");
              closeSidebar();
            }}
          >
            <ClipboardList size={18} />
            Job Forms
          </button>
        )}

        <div className="sb-section">MANAGEMENT</div>

        {role !== "staff" && (
          <button
            className={`sb-btn ${isActive("/users") ? "act" : ""}`}
            onClick={() => {
              navigate("/users");
              closeSidebar();
            }}
          >
            <Users size={18} />
            User Management
          </button>
        )}

        <button
          className={`sb-btn ${isActive("/job/reports") ? "act" : ""}`}
          onClick={() => {
            navigate("/job/reports");
            closeSidebar();
          }}
        >
          <BarChart3 size={18} />
          Reports
        </button>

        <div className="sb-spacer"></div>

        {/* ✅ PROFILE BUTTON */}
        <button
          className="sb-btn"
          onClick={() => {
            console.log("Opening profile modal..."); // debug
            window.dispatchEvent(new Event("openProfileModal"));
            closeSidebar();
          }}
        >
          <User size={18} />
          Profile Management
        </button>

        {/* USER INFO */}
        <div className="sb-user">
          <div className="sb-ava">
            {user?.name ? user.name.charAt(0) : "U"}
          </div>
          <div>
            <div className="sb-uname">{user?.name || "Guest"}</div>
            <div className="sb-urole">{user?.role || "User"}</div>
          </div>
        </div>

        <button className="sb-btn logout" onClick={handleLogout}>
          <LogOut size={18} />
          Logout
        </button>

      </div>
    </aside>
  );
}

export default Sidebar;